import TPBBottomActions from './TPBBottomActions.component';

export default TPBBottomActions;
